import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "content", "image", "iframe"]

  connect() {
    console.log("Lightbox controller connected")
  }

  disconnect() {
    this.toggleScrollLock(false, true)
  }

  open(event) {
    event.preventDefault()
    const url = event.currentTarget.href
    const isPdf = url.toLowerCase().endsWith(".pdf") || event.currentTarget.dataset.fileType === "application/pdf"

    this.modalTarget.classList.remove("hidden")
    this.modalTarget.classList.add("flex")
    this.toggleScrollLock(true)

    if (isPdf) {
      this.imageTarget.classList.add("hidden")
      this.iframeTarget.classList.remove("hidden")
      this.iframeTarget.src = url
    } else {
      this.iframeTarget.classList.add("hidden")
      this.imageTarget.classList.remove("hidden")
      this.imageTarget.src = url
    }
  }

  close() {
    this.modalTarget.classList.add("hidden")
    this.modalTarget.classList.remove("flex")
    this.toggleScrollLock(false)
    this.imageTarget.src = ""
    this.iframeTarget.src = ""
  }

  toggleScrollLock(lock, force = false) {
    const body = document.body
    const html = document.documentElement
    let openModals = parseInt(body.dataset.openModals || "0")

    if (lock) {
      openModals++
      body.dataset.openModals = openModals
      
      if (openModals === 1) {
        this.scrollPos = window.pageYOffset
        body.style.position = 'fixed'
        body.style.top = `-${this.scrollPos}px`
        body.style.width = '100%'
        body.classList.add('overflow-hidden')
        html.classList.add('overflow-hidden')
      }
    } else {
      openModals = force ? 0 : Math.max(0, openModals - 1)
      body.dataset.openModals = openModals
      
      if (openModals === 0) {
        const scrollY = body.style.top
        body.style.position = ''
        body.style.top = ''
        body.style.width = ''
        body.classList.remove('overflow-hidden')
        html.classList.remove('overflow-hidden')
        if (!force) {
          window.scrollTo(0, parseInt(scrollY || '0') * -1)
        }
      }
    }
  }

  handleEsc(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }
}
